<div [ngClass]="{'hidden': !areRviewsLoaded}" class="page">
    <header>
        <div class="container-fluid">
            <app-header></app-header>
        </div>
    </header>
    <div class="container-fluid">
        <router-outlet></router-outlet>
    </div>

    <div class="container-fluid">
        <footer>
            <!--<app-footer></app-footer>-->
        </footer>
    </div>
</div>
<!--<div [ngClass]="{'hidden': isTranslationAvailable}" class="loading">-->
<!--<div class="loading__spinner">-->
<!--<span></span>-->
<!--</div>-->
<!--</div>-->




// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/app.component.html